import { TypographyStyleOptions } from '@mui/material/styles/createTypography';
import { css } from 'styled-components';

export const typographyToCss = (typography: TypographyStyleOptions) => css`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize};
  font-weight: ${typography.fontWeight};
  line-height: ${typography.lineHeight};
`;
